export default __webpack_public_path__ + "static/media/eb-ultra-blk-banner-3.59a272b2.jpg";